/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AuditHistoryDto as OkEgisServiceModelsDtoAuditHistoryDto } from '../models/OK/Egis/Service/Models/DTO/audit-history-dto';
import { HistoryRemarkCreateDto as OkEgisServiceModelsDtoHistoryRemarkCreateDto } from '../models/OK/Egis/Service/Models/DTO/history-remark-create-dto';
import { HistoryRemarkUpdateDto as OkEgisServiceModelsDtoHistoryRemarkUpdateDto } from '../models/OK/Egis/Service/Models/DTO/history-remark-update-dto';
import { AuditHistoryEnum as OkEgisServiceModelsEntitiesEnumsAuditHistoryEnum } from '../models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';

@Injectable({
  providedIn: 'root',
})
export class HistoryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAuditHistoryForEntity
   */
  static readonly GetAuditHistoryForEntityPath = '/api/v1/History/GetAuditHistoryForEntity';

  /**
   * Returns the history for the entity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuditHistoryForEntity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditHistoryForEntity$Response(params: {

    /**
     * Id of the entity for which history is requested
     */
    id?: number;

    /**
     * Id of the type of history, corresponding to AuditHistoryEnum values
     */
    auditHistoryEnum?: OkEgisServiceModelsEntitiesEnumsAuditHistoryEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoAuditHistoryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HistoryService.GetAuditHistoryForEntityPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
      rb.query('auditHistoryEnum', params.auditHistoryEnum, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoAuditHistoryDto>>;
      })
    );
  }

  /**
   * Returns the history for the entity.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAuditHistoryForEntity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditHistoryForEntity(params: {

    /**
     * Id of the entity for which history is requested
     */
    id?: number;

    /**
     * Id of the type of history, corresponding to AuditHistoryEnum values
     */
    auditHistoryEnum?: OkEgisServiceModelsEntitiesEnumsAuditHistoryEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoAuditHistoryDto>> {

    return this.getAuditHistoryForEntity$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoAuditHistoryDto>>) => r.body as Array<OkEgisServiceModelsDtoAuditHistoryDto>)
    );
  }

  /**
   * Path part for operation addHistoryRemark
   */
  static readonly AddHistoryRemarkPath = '/api/v1/History/AddHistoryRemark';

  /**
   * Creates a remark in the history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addHistoryRemark()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHistoryRemark$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoHistoryRemarkCreateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, HistoryService.AddHistoryRemarkPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>;
      })
    );
  }

  /**
   * Creates a remark in the history.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addHistoryRemark$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHistoryRemark(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoHistoryRemarkCreateDto
  }): Observable<OkEgisServiceModelsDtoAuditHistoryDto> {

    return this.addHistoryRemark$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>) => r.body as OkEgisServiceModelsDtoAuditHistoryDto)
    );
  }

  /**
   * Path part for operation deleteRemark
   */
  static readonly DeleteRemarkPath = '/api/v1/History/DeleteRemark';

  /**
   * marks a History Remark as deleted.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRemark()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRemark$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, HistoryService.DeleteRemarkPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>;
      })
    );
  }

  /**
   * marks a History Remark as deleted.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteRemark$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRemark(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoAuditHistoryDto> {

    return this.deleteRemark$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>) => r.body as OkEgisServiceModelsDtoAuditHistoryDto)
    );
  }

  /**
   * Path part for operation editRemark
   */
  static readonly EditRemarkPath = '/api/v1/History/EditRemark';

  /**
   * Edits the text of a remark.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editRemark()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editRemark$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoHistoryRemarkUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, HistoryService.EditRemarkPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>;
      })
    );
  }

  /**
   * Edits the text of a remark.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `editRemark$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editRemark(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoHistoryRemarkUpdateDto
  }): Observable<OkEgisServiceModelsDtoAuditHistoryDto> {

    return this.editRemark$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAuditHistoryDto>) => r.body as OkEgisServiceModelsDtoAuditHistoryDto)
    );
  }

}
